module.exports = __webpack_public_path__ + "static/media/bnr11.aa25ffa3.jpg";